export const TENANT_ID = process.env.TENANTID
  ? process.env.TENANTID
  : 'ten_I9TW3ncG';
export const TENANT = process.env.TENANT ? process.env.TENANT : 'planet';
